import { render, staticRenderFns } from "./DashboardWidgetFabbisognoFinanziario.vue?vue&type=template&id=ecc23340&"
import script from "./DashboardWidgetFabbisognoFinanziario.vue?vue&type=script&lang=js&"
export * from "./DashboardWidgetFabbisognoFinanziario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports